import { applyMiddleware, createStore, compose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'redux/reducers';
import sagas from 'redux/sagas';

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger({});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store;

if (process.env.NODE_ENV === 'development')
	store = createStore(rootReducer, composeEnhancers(applyMiddleware(logger, sagaMiddleware)));
else store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));

export default store;

sagaMiddleware.run(sagas);
